import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { withPlugin } from '@core/hoc/withPlugin'
import setCalendar from '@app/ac/set-calendar'
import setCalendarFilters from '@app/ac/set-calendar-filters'
import setOffers from '@app/action/set-offers'
import loadWorkspaceEvents from '@app/ac/load-workspace-events'
import { loadRoleStatsMulti, setModal } from '@app/ac'
import { openedManagerAssistantPlanning } from '@app/reducer/manager-assistant'

const mapStateToProps = ({ calendar, calendarFilters, managerAssistant, shifts, availabilities, timeOffs, employees, offers, positions, workspaces, workspaceId, auth, userId, modal }) => {
  const ws = workspaces && workspaceId ? workspaces.find(ws => ws.id === workspaceId) : null
  return {
    auth,
    isPlanningPanelOpen: managerAssistant.planningOpen,
    calendar: calendar || {},
    calendarFilters,
    shifts,
    availabilities,
    timeOffs,
    offers,
    employees,
    positions,
    workspace: ws,
    userId,
    modal
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setCalendar,
    setCalendarFilters,
    openPlanning: openedManagerAssistantPlanning,
    loadWorkspaceEvents,
    loadRoleStatsMulti,
    setOffers,
    setModal
  }, dispatch)
}

export default (component) => {
  return compose(
    withPlugin,
    connect(mapStateToProps, mapDispatchToProps))(component)
}
